module.exports = __webpack_public_path__ + "static/requirements-img-46370f00444d892985adf27a3e6f0f86.png";